import fever from '@/assets/customer-logo-fever.png.asset.json';
import immersive from '@/assets/customer-logo-immersive-homes.png.asset.json';
import stationA from '@/assets/customer-logo-station-a.png.asset.json';
import solarApp from '@/assets/customer-logo-solarapp.png.asset.json';
import kora from '@/assets/customer-logo-kora.png.asset.json';

const logos = [
  { src: fever.url, alt: 'Fever', h: 'h-8 md:h-9' },
  { src: stationA.url, alt: 'Station A', h: 'h-6 md:h-7' },
  { src: solarApp.url, alt: 'SolarAPP+', h: 'h-10 md:h-12' },
  { src: immersive.url, alt: 'Immersive Homes', h: 'h-6 md:h-7' },
  { src: kora.url, alt: 'Kora', h: 'h-5 md:h-6' },
];

const CustomerLogos = ({ className = '' }: { className?: string }) => (
  <section aria-label="Customers" className={`bg-fordje-navy py-10 md:py-12 ${className}`}>
    <div className="container-custom">
      <p className="text-center text-xs font-semibold tracking-widest uppercase text-fordje-gray mb-8">
        Trusted by teams at
      </p>
      <ul className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8 md:gap-x-16">
        {logos.map((l) => (
          <li key={l.alt}>
            <img
              src={l.src}
              alt={l.alt}
              loading="lazy"
              className={`${l.h} w-auto opacity-70 hover:opacity-100 transition-opacity`}
            />
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default CustomerLogos;
